import React, { Component } from "react";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
// import MenuItem from '../common/MenuItem'
import Checkbox from "../common/Checkbox";
import { errorHandler } from "../../Helpers";
// import CustomDialog from './Dialog';
import Stepper from "./Stepper";
import moment from "moment";
import DateRangePicker from "./DateRangePicker";
// import TextField from './TextField';
import { Grid, FormControlLabel, MenuItem } from "@mui/material";
import Loader from "../../Layout/Loader";
// import Button from './Button';
import VehicleSelector from "./VehicleSelector";
import AccountSelector from "./AccountSelector";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// // // import Menu from '../Menu/CommonMenu'
import AreaSelector from "./AreaSelector";
import Scrollbar from "react-scrollbars-custom";
import Button from "../common/Button";
import { GetApp } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import TextField from "../common/TextField";
// let contractTypes = [
//   { id: 1, name: "valid only" },
//   { id: 2, name: "Leasing" },
// ];
export default class bulkInvoiceFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFilterModal: false,
      from: "",
      to: "",
      selectedDate: "",
      vehicleId: [],
      contractNumber: [],
      areaId: [],
      loader: false,
      countChecked: 0,
      anchorEl: null,
      selectedvehicleId: [],
      selectedaccountId: [],
      selectedAreaId: [],
      steps: [
        { id: 1, title: "selectServiceTimeControl" },
        { id: 2, title: "selectAccount" },
        // ,{id: 3, title: 'selectVehicles'},{id:4, title:'selectAreaIds'}
      ],
      singleAccountSteps: [
        { id: 1, title: "selectServiceTimeControl" },
        // , {id: 2, title: 'selectAccount'} ,{id: 3, title: 'selectVehicles'},{id:4, title:'selectAreaIds'}
      ],
      activeStep: 0,
      reportType: 0,
      isSubmitBtn: false,
      invalidOnly :false
    };
  }

  onCloseDueMaintenanceModel = () => {
    this.setState({
      openFilterModal: false,
      to: "",
      from: "",
      isSubmitBtn: false,
      selectedDate: "",
      from: "",
      to: "",
      vehicleId: [],
      areaId: [],
      contractNumber: [],
      countChecked: 0,
      anchorEl: null,
      activeStep: 0,
    });
  };

  showDates = (e, date) => {
    const duration = moment.duration(
      moment(this.state.to).diff(this.state.from)
    );
    const hours = duration.asHours();
    let timezone = "Asia/Dubai";
    if (
      this.props.ServerSetting &&
      this.props.ServerSetting.attributes &&
      this.props.ServerSetting.attributes.timezone
    ) {
      timezone = this.props.ServerSetting.attributes.timezone;
    }
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      timezone = this.props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);

    var formatedDate = {
      from: moment(date.startDate.format("YYYY-MM-DD HH:mm")).toISOString(),
      to: moment(date.endDate.format("YYYY-MM-DD HH:mm")).toISOString(),
    };

    let timeFormat = "HH:mm";

    if (this.props.logInUser && this.props.logInUser.twelveHourFormat) {
      timeFormat = "hh:mm A";
    }

    this.setState({
      selectedDate:
        moment(date.startDate).format("YYYY-MM-DD " + timeFormat) +
        " - " +
        moment(date.endDate).format("YYYY-MM-DD " + timeFormat),
      ...formatedDate,
    });
  };

  handleChange = (name, e) => {
    if (e === "area") {
      this.setState({
        areaId: name,
      });
      this.setState({ areaId: name }, () => {
        let filter = "";
        Object.entries(this.state.areaId).map(([key, value]) => {
          if (value) {
            filter += "&areaId=" + value;
            this.setState({});
          }
        });
        this.setState({
          selectedAreaId: filter,
        });
      });
    } else if (e === "vehicle") {
      this.setState({
        vehicleId: name,
      });
      this.setState({ vehicleId: name }, () => {
        let filter = "";
        Object.entries(this.state.vehicleId).map(([key, value]) => {
          if (value) {
            filter += "&vehicleId=" + value;
            this.setState({});
          }
        });
        this.setState({
          selectedvehicleId: filter,
        });
      });
    } else {
      this.setState({
        contractNumber: name,
      });
      this.setState({ contractNumber: name }, () => {
        let filter = "";
        Object.entries(this.state.contractNumber).map(([key, value]) => {
          if (value) {
            filter += "&contractNumber=" + value;
            this.setState({});
          }
        });
        this.setState({
          selectedaccountId: filter,
        });
      });
    }
  };

  validatedForm = (step, type, index) => {
    let validated = false;
    let errorMsg = null;

    if (this.state.to && this.state.from) {
      validated = true;
      errorMsg = null;
      this.setState({ isSubmitBtn: true });
    } else {
      validated = false;
      errorMsg = (
        <span className="text-warning">
          Please select 'Date and Maintenance Status' from above
        </span>
      );
    }

    if (this.props.singleAccount) {
      validated = true;
    } else {
      if (this.state.selectedaccountId.length > 0) {
        validated = true;
        errorMsg = null;
        this.setState({ isSubmitBtn: true });
      } else {
        validated = false;
        errorMsg = (
          <span className="text-warning">
            Please select atleast one account
          </span>
        );
      }
    }
    if (validated === true) {
      this.setState({}, () => this.handleNext(step, type, index));
    } else {
      validated = false;
      errorMsg = (
        <span className="text-warning">
          Please select 'Date and Maintenance Status' from above
        </span>
      );
    }
  };

  handleNext = (step, type, index) => {
    // if (validated === true) {
    this.setState({}, () => {
      if (type === "downloadExcel" || type === "downloadPdf") {
        this.props.regenerateInvoices(
          this.state.to,
          this.state.from,
          this.state.selectedaccountId,
          this.state.invalidOnly,
          type
        );
      } else {
        this.props.regenerateInvoices(
          this.state.to,
          this.state.from,
          this.state.selectedaccountId,
          this.state.invalidOnly,
        );
      }
    });
    // }
  };

  goToNextStep = (step, type, index) => {
    if (this.props.singleAccount) {
      let filter = "";
      filter = "&contractNumber=" + this.props.selectedAccount?.contractNumber;
      this.setState({
        selectedaccountId: filter,
      });

      if (step === 1) {
        this.setState({}, () => {
          if (type === "downloadExcel" || type === "downloadPdf") {
            this.props.downloadInvoices(
              this.state.to,
              this.state.from,
              this.state.selectedaccountId,
              type
            );
          } else {
            this.props.paymentFilter(
              this.state.to,
              this.state.from,
              this.state.selectedaccountId
            );
          }
        });
      } else {
        this.validatedCurrentStep(step, type, index);
      }
    } else {
      if (step === 2) {
        this.setState({}, () => {
          if (type === "downloadExcel" || type === "downloadPdf") {
            this.props.downloadInvoices(
              this.state.to,
              this.state.from,
              this.state.selectedaccountId,
              type
            );
          } else {
            this.props.paymentFilter(
              this.state.to,
              this.state.from,
              this.state.selectedaccountId
            );
          }
        });
      } else {
        this.validatedCurrentStep(step, type, index);
      }
    }
  };

  goToBackStep = () => {
    const currentStep = this.state.activeStep;
    this.setState({ activeStep: currentStep - 1 });
  };

  validatedCurrentStep = (step, type, index) => {
    const steps = [];
    let validated = false;
    let errorMsg = null;

    if (step === 1) {
      if (this.state.to && this.state.from) {
        validated = true;
        errorMsg = null;
        this.setState({ isSubmitBtn: true });
      } else {
        validated = false;
        errorMsg = (
          <span className="text-warning">
            Please select 'Date and Maintenance Status' from above
          </span>
        );
      }
    } else if (step === 2) {
      if (this.props.singleAccount) {
        validated = true;
      } else {
        if (this.state.selectedaccountId.length > 0) {
          validated = true;
          errorMsg = null;
        } else {
          validated = false;
          errorMsg = (
            <span className="text-warning">
              Please select atleast one account
            </span>
          );
        }
      }
    }

    //   else if(step === 3) {
    //       validated = true
    // }

    if (validated === true) {
      if (this.props.singleAccount) {
        this.setState({ activeStep: index + 1 }, () => {
          if (this.state.activeStep === 1) {
            this.setState({ isSubmitBtn: true });
          }
        });
      } else {
        this.setState({ activeStep: index + 1 }, () => {
          if (this.state.activeStep === 2) {
            this.setState({ isSubmitBtn: true });
          }
        });
      }
    }

    if (this.props.singleAccount) {
      this.state.singleAccountSteps.map((s) => {
        if (s.id === step) {
          steps.push({ ...s, errorMsg });
        } else steps.push(s);

        return null;
      });
      this.setState({ steps });
    } else {
      this.state.steps.map((s) => {
        if (s.id === step) {
          steps.push({ ...s, errorMsg });
        } else steps.push(s);

        return null;
      });
      this.setState({ steps });
    }
  };

  getStepContent = (id) => {
    if (this.props.singleAccount) {
      switch (id) {
        case 1:
          return (
            <Grid container className="form-group sidebar-bg-layer">
              <Grid item xs={12}>
                {/* Date */}
                <DateRangePicker
                  fill
                  error={this.props.timeError || false}
                  selectedDate={this.state.selectedDate}
                  label={
                    this.props.translate("reportFrom") +
                    " " +
                    this.props.translate("reportTo")
                  }
                  onEvent={this.showDates}
                />
              </Grid>
            </Grid>
          );

        default:
          return null;
      }
    } else {
      switch (id) {
        case 1:
          return (
            <Grid container className="form-group sidebar-bg-layer">
              <Grid item xs={12}>
                {/* Date */}
                <DateRangePicker
                  fill
                  error={this.props.timeError || false}
                  selectedDate={this.state.selectedDate}
                  label={
                    this.props.translate("reportFrom") +
                    " " +
                    this.props.translate("reportTo")
                  }
                  onEvent={this.showDates}
                />
              </Grid>
              <Grid item xs={12}>
                
                <AccountSelector
                  api="accounts"
                  contractType={this.props.contractType}
                  fill
                  hideIcons
                  isClearable
                  placeholder={this.props.translate("searchAccount")}
                  onChange={this.handleChange}
                  value={this.state?.contractNumber || []}
                />
              </Grid>
            </Grid>
          );
        case 2:
          return (
            <Grid container className="form-group">
              <Grid item xs={12}>
                {/*  */}
                <AccountSelector
                 contractType={this.props.contractType}
                  api="accounts"
                  fill
                  hideIcons
                  isClearable
                  placeholder={this.props.translate("searchAccount")}
                  onChange={this.handleChange}
                  value={this.state?.contractNumber || []}
                />
              </Grid>
            </Grid>
          );

        default:
          return null;
      }
    }
  };

  handleChangeCheckBox = (name, e) => {
    const { checked } = e.target;
    this.setState({
      [name]: checked
    });
  }

  render() {
    const viewScreen = (
      <form style={{ padding: "16px 0 16px 10px" }}>
        {
          <>
            {/* {console.log("==>singleAccount", this.props.singleAccount)} */}
            <h3>Regenerate Invoices </h3>
            <Grid container className="form-group sidebar-bg-layer">
              <Grid item xs={12} style={{ padding: 10 }}>
                {/* Date */}
                <DateRangePicker
                  fill
                  error={this.props.timeError || false}
                  selectedDate={this.state.selectedDate}
                  label={
                    this.props.translate("reportFrom") +
                    " " +
                    this.props.translate("reportTo")
                  }
                  onEvent={this.showDates}
                />
              </Grid>
              {this.props.singleAccount ? (
                ""
              ) : (
                <Grid item xs={12} style={{ padding: 10 }}>
                  {/*  */}
                  <AccountSelector
                   contractType={this.props.contractType}
                    api="accounts"
                    fill
                    hideIcons
                    isClearable
                    placeholder={this.props.translate("searchAccount")}
                    onChange={this.handleChange}
                    value={this.state?.contractNumber || []}
                  />
                </Grid>
              )}

              <Grid item xs={12} style={{ padding: 10 }}>
              {/* <TextField
              id="contractType"
              select
              label={this.props.translate("contractType")}
              value={this.props.contractType || ""}
              onChange={(e) => this.props.handleChange("contractType", e)}
              SelectProps={{
                MenuProps: {
                  // className: classes.menu,
                },
              }}
              margin="dense"
              fullWidth
              // helperText={this.props.roleTypes.length ? <span onClick={this.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
              required
            >
              {contractTypes.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {this.props.translate(option.name)}
                </MenuItem>
              ))}
            </TextField> */}
              <Checkbox
                  checked={this.state.invalidOnly}
                  onChange={(e)=>this.handleChangeCheckBox("invalidOnly",e)}
                  label={this.props.translate("invalidOnly")}
                />
                </Grid>
              <Grid item xs={12} style={{ padding: 10 }}>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: 20,
                    }}
                  >
                    <Button
                      // disabled={this.state.isSubmitBtn ? "" : "disabled"}
                      variant="contained"
                      color="primary"
                      // downloadInvoices={this.props.downloadInvoices}
                      onClick={(e) => this.validatedForm("", "", "")}
                      style={{
                        margin: 5,
                        // height: "30px",
                        // width: "60px",
                      }}
                    >
                      {/* <GetApp /> */}
                      {this.props.translate("Regenerate")}
                    </Button>
                    {/* <Button
                      onClick={(e) => this.validatedForm("", "", "")}
                      style={{
                        margin: 5,
                        height: "30px",
                        width: "60px",
                      }}
                    >
                      Submit
                    </Button> */}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        }
      </form>
    );

    return (
      <div className="geofence-sidebar-list">
        {/* <Scrollbar>{viewScreen}</Scrollbar> */}
        {!this.props.loader ? (
          <Scrollbar>{viewScreen}</Scrollbar>
        ) : (
          <Loader component="filter" />
        )}
      </div>
    );
  }
}
